import React from 'react'
import styles from './about-us.scss'
import about_1 from '../../common/images/about/about-1.jpg'
import yd_about from '../../common/images/about/yd-about.png'
import about_tow from '../../common/images/about/about-2.jpg'
import about_3 from '../../common/images/about/about-3.png'
import one from '../../common/images/solution/01.png'
import two from '../../common/images/solution/02.png'
import three from '../../common/images/solution/03.png'
// import group from '../../common/images/about/group.png'
import group_yd from '../../common/images/about/group-yd.png'
// import major from '../../common/images/about/major.png'
import major_yd from '../../common/images/about/major-yd.png'
import address from '../../common/images/about/address.jpg'
import addressPC from '../../common/images/about/address-pc.jpg'
import chapterPc from '../../common/images/about/chapter-pc.jpg'
import chapter from '../../common/images/about/chapter.jpg'
const AboutUs = (props) => {
  return <section className={styles['about-us']}>
    <div className={styles['about-contnet']}>
      <div className={styles['about-1']}>
        <div>
          <h2>智能财税SAAS服务商</h2>
          <p>为代理记账公司、中小企业提供智能财税软件及高端增值业务</p>
          <p>打造一体化智能解决方案</p>
        </div>
        <img src={about_1} alt='about_1' className={styles['about_one']} />
        <img src={yd_about} alt='yd-about' className={styles['yd-about']} />
      </div>
      <div className={styles['about']}>
        <img src={about_3} alt='about_3' />
        <div className={styles['about-us-s']}>
          <h3>About Us</h3>
          <h4>概而论网络科技有限公司</h4>
          <p>
            宁波概而论网络科技有限公司是一家以互联网平台运营、云计算、大数据分析、WEB应用开发、软件开发、人工智能等项目为核心的科技公司。
          </p>
          <p>
            旗下的“云代账”和“云生态”产品采用SaaS模式,专为代账机构设计。有助于代账公司完善企业内控体系、优化成本结构，同时提供生态增值产品，为代账公司拓展多元经营提供新方向。
          </p>
          <p>
            自2023年起，概而论参与了国家电子凭证会计数据标准深化试点的工作，打通了电子凭证从采集,处理至归档的全流程，实现了会计处理流程的标准化、无纸化。
          </p>
          <p>
            概而论分别在杭州、上海、成都、武汉、长沙、合肥、宁波等地建立服务中心。支持33个省份和自治区，并与近百万家企事业单位达成合作。公司将秉承“为客户创造价值”的理念,通过不断探索与创新,深度打造财税行业全场景解决方案。
          </p>
        </div>
      </div>
      <div className={styles['address_yd']} >
        <img src={address} alt='address_yd' />
      </div>
      <div className={styles['statistic_yd']}>
        <div className={styles['statistic']}>
          <div className={`${styles['number']} ${styles['orange']}`}>33</div>
          <div className={styles['description']}>支持33个省份和自治区</div>
        </div>
        <div className={styles['statistic']}>
          <div className={`${styles['number']} ${styles['blue']}`}><span>近</span>100W</div>
          <div className={styles['description']}>为近百万客户提供服务</div>
        </div>
      </div>
      <div className={styles['chapter_yd']} >
        <img src={chapter} alt='chapter_yd' />
      </div>
      <div className={styles['advantage']}>
        <div>
          {/* <img src={group} alt='group' className={styles['group']} /> */}
          <img src={group_yd} alt='group_yd' className={styles['group_yd']} />
        </div>
        <ul>
          <li>
            <div><img src={one} alt='one' /></div>
            <h3>专业的团队</h3>
            <span></span>
            <div className={styles['advantage_content']}>
              <p>核心团队拥有20多年的财税服务经验，运用AI智能技术，开启智能财税新时代。</p>
              <div>
                <p>核心团队拥有20多年的财税服务经验</p>
                <p>运用AI智能技术</p>
                <p>开启智能财税新时代</p>
              </div>
            </div>
          </li>
          <li>
            <div><img src={two} alt='two' /></div>
            <h3>丰富的经验</h3>
            <span className={styles['advantage_bgOne']}></span>
            <div className={styles['advantage_content']}>
              <p>在中小企业和财税服务公司中有多年的服务经验，在服务实践过程中针对不同的行业推出了不同的版本。</p>
              <div>
                <p>在中小企业和财税服务公司中有多年的服务经验</p>
                <p>在服务实践过程中</p>
                <p>针对不同的行业推出了不同的版本</p>
              </div>
            </div>
          </li>
          <li>
            <div><img src={three} alt='three' /></div>
            <h3>我们的模式</h3>
            <span className={styles['advantage_bgTwo']}></span>
            <div className={styles['advantage_content']}>
              <p>概而论为企业成长赋能。概而论不断优化产品功能，迭代无感升级。让产品更简单，更智能。</p>
              <div>
                <p>概而论为企业成长赋能</p>
                <p>概而论不断优化产品功能，迭代无感升级</p>
                <p>让产品更简单，更智能</p>
              </div>
            </div>
          </li>
        </ul>
        <div className={styles['major']}>
          {/* <img src={major} alt='major' /> */}
        </div>
        <div className={styles['address']} >
          <img src={addressPC} alt='address' />
        </div>
        <div className={styles['chapter']} >
          <img src={chapterPc} alt='chapter' />
        </div>
        <div className={styles['major_yd']}>
          <img src={major_yd} alt='major_yd' className={styles['major_yd']} />
        </div>
      </div>
      <div className={styles['about_tow']}>
        <img src={about_tow} alt='about_tow' className={styles['about_img']} />
      </div>
    </div>
    <div className={styles['about-contnet_x']}>
    </div>
  </section>
}

export default AboutUs
